export default __webpack_public_path__ + "static/media/photo--sm--43.c5351196.jpg";